<app-page-meta pageTitle="finzy - Investor Wallet"></app-page-meta>
<app-header></app-header>

<div class="container-fluid">
    <div class="row">
        <app-investormenu></app-investormenu>
        <div class="col-xs-12 col-md-10 col-lg-11">
            <div *ngIf="!shouldShowDataLoader" class="spinner-section">
                <mat-spinner [diameter]="35" class="col-xs-offset-6"></mat-spinner>
            </div>
            <div *ngIf="shouldShowDataLoader">
                <div class="row text-center">
                    <p class="finzy-txt-wallet">Current Investment Wallet Balance</p>
                    <p class="wallet-amt"><span class="rs-small"></span> {{wallet | indianCurrency}}</p>
                    <div class="row">
                        <p *ngIf="areAutomaticInvestmentsFromWalletEnabled()"
                           class="col-xs-10 col-xs-offset-1 col-sm-6 col-sm-offset-3 text-color-grey">
                            <i class="fa fa-info-circle text-color-finzy-blue"></i>
                            You have opted for finzyBolt! Any money in your wallet will be used to create portfolios
                            automatically. You can change your
                            preference <a [routerLink]="['/preferences']">here</a>.
                        </p>
                    </div>
                </div>
                <div class="row">
                    <p class="finzy-txt1" *ngIf="lender_application_status=='invested'">To view your Investment Wallet
                        transactions <a
                                class="clicka" (click)="openDiv()">Click here</a></p>
                </div>

                
                <div class="row finzy-datatable" [hidden]="!walletTransactions">
                    <mat-table #table [dataSource]="dataSource" matSort>

                        <ng-container matColumnDef="timestamp">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Date</mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{element.timestamp | dateFormat}}</mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="transaction_type">
                            <mat-header-cell *matHeaderCellDef> Transaction Type</mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{element.transaction_type | uppercase }}</mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="amount">
                            <mat-header-cell *matHeaderCellDef mat-sort-header> Amount</mat-header-cell>
                            <mat-cell *matCellDef="let element">
                                ₹ {{element.amount | decimal | number : fractionSize}}</mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                    </mat-table>

                    <mat-paginator #paginator [length]="5"
                                [pageSize]="5"
                                [pageSizeOptions]="[5, 10, 20]">
                    </mat-paginator>
                </div>
                <ng-container *ngIf="!isFINXLender">
                    <div class="row greydiv-online-payment">
                        <p class="finzy-txt-online-payment">You can top-up your wallet by choosing an online payment method</p>
                        <div class="online-payment-box">
                            <p class="finzy-txt3">Enter the amount</p>
                            <form name="form" (keydown.enter)="$event.preventDefault()"
                            (ngSubmit)="topupAmountForm.form.valid && onAddMoneyClick(topupAmount)"
                            #topupAmountForm="ngForm">
                                <div class="topup-amount">
                                    <mat-form-field [ngClass]="{disable_background: isFINXLender}">
                                        <span matPrefix style="font-size: 122%">₹&nbsp;</span>
                                        <input matInput class="topup-amount-input" [(ngModel)]="topupAmount"
                                        name="topupAmount" type="number" [disabled]="isFINXLender" onKeyPress="if(this.value.length==10) return false;">
                                    </mat-form-field>
                                </div>
                                <div class="row finzy-create-portfolio-err">
                                    <span class="finzy-red" *ngIf="topupAmount <= 0">Please enter the valid amount</span>
                                </div>
                                <div class="topup-amount-submit-section">
                                    <div *ngIf="dataLoader === true" class="loader wallet-submit-loader">
                                        <mat-spinner [diameter]="35"></mat-spinner>
                                    </div>
                                    <button *ngIf="dataLoader === false" class="topup-amount-submit-btn" type="submit" mat-flat-button
                                    [disabled]="!isFormValid(topupAmountForm.valid)">ADD MONEY</button>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div class="row">
                        <p class="section-break"> <span class="mid-text"> OR </span> </p>
                    </div>


                    <div class="row greydiv">
                    <p class="finzy-txt2">You can top-up your wallet by <strong>transferring funds</strong>  to this bank account:</p>
                        <div class="summary">
                            <div class="row">
                                <p class="key col-md-3 col-md-offset-3">Account Name</p>
                                <p class="value col-md-6">BRIDGE FINTECH SOLUTIONS PVT LTD</p>
                            </div>
                            <div class="row">
                                <p class="key col-md-3 col-md-offset-3">Bank</p>
                                <p class="value col-md-6">ICICI BANK</p>
                            </div>
                            <div class="row">
                                <p class="key col-md-3 col-md-offset-3">Virtual Account Number</p>
                                <p class="value col-md-6" *ngIf="virtualAccountId">
                                    <span>{{getSubstring(virtualAccountId, 0, 10)}}</span><span><b>{{getSubstring(virtualAccountId, 10, virtualAccountId.length)}}</b> &nbsp;&nbsp;</span>
                                    <span class="font-14px" (click)="openVirtualAccountDescription()"><a class="finzy-col cursor-pointer">How does this work?</a></span>
                                </p>
                            </div>
                            <div class="row">
                                <p class="key col-md-3 col-md-offset-3">Account Type</p>
                                <p class="value col-md-6">CURRENT ACCOUNT</p>
                            </div>
                            <div class="row">
                                <p class="key col-md-3 col-md-offset-3">IFSC Code</p>
                                <p class="value col-md-6">ICIC0000104</p>
                            </div>
                        </div>
                    </div>

                    <!-- for mobile view -->
                    <div class="row greydivmob">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-sm-6 walletleft">
                                    <p class="greytxtr">Account Name </p>
                                </div>
                                <div class="col-sm-6 walletright">
                                    <p class="greytxtl"> BRIDGE FINTECH SOLUTIONS PVT LTD</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6 walletleft">
                                    <p class="greytxtr">Bank </p>
                                </div>
                                <div class="col-sm-6 walletright">
                                    <p class="greytxtl"> ICICI BANK</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6 walletleft">
                                    <p class="greytxtr">Virtual Account Number </p>
                                </div>
                                <div class="col-sm-6 walletright" *ngIf="virtualAccountId">
                                    <span>{{getSubstring(virtualAccountId, 0, 10)}}</span><span><b>{{getSubstring(virtualAccountId, 10, virtualAccountId.length)}}</b> &nbsp;&nbsp;</span>
                                    <span class="font-14px" (click)="openVirtualAccountDescription()"><a class="finzy-col cursor-pointer">How does this work?</a></span>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6 walletleft">
                                    <p class="greytxtr">Account Type </p>
                                </div>
                                <div class="col-sm-6 walletright">
                                    <p class="greytxtl"> CURRENT ACCOUNT</p>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-sm-6 walletleft">
                                    <p class="greytxtr">IFSC Code </p>
                                </div>
                                <div class="col-sm-6 walletright">
                                    <p class="greytxtl"> ICIC0000104</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </ng-container>
                <ng-container *ngIf="isFINXLender">
                    <div class="col-md-8 col-md-offset-2">
                        <div class="row finzy-prov-div">
                            <p class="finzy-prov-2">
                                We have launched a new and easier interface for your investments in finzyFLEX. 
                                Please logout from your current profile and log in with your PAN number to continue investing.
                                You can know more about finzyFLEX here: 
                                <a href="https://finzy.com/faq?selectedTab=FINZY_FLEX" target="_blank">
                                    https://finzy.com/faq
                                </a>
                            </p>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="!isFINXLender">
                    <div class="row">
                        <p class="col-12 center-align-text finzy-p6">Please note: finzy (Bridge Fintech Solutions Private
                            Limited)
                            encourages electronic transfer to above escrow bank account.
                            Please do not handover any cheque or cash to our employees or any representative.</p>
        
                        <p class="finzy-p6">
                            If you need assistance you can find help here <span class="finzy-col">FAQs</span>. You could even
                            call us on
                            9341 300 300. We are always happy to help!</p>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>

<app-footer></app-footer>
